module.exports = __webpack_public_path__ + "static/img/pattrick1-bg.60f5b7f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/topImg/pattrick1-bg.jpg
// module id = pV4h
// module chunks = 9